import moment, { type Moment } from 'moment';
import React, { useEffect, useState } from 'react';
import type { RouteComponentProps } from 'react-router-dom';

import history from 'utils/history';
import useTitle from 'hooks/useTitle';
import HolidayForm from './HolidayForm';
import * as routes from 'constants/routes';
import { handleError } from 'utils/errorHandler';
import * as holidayService from 'services/holidays';
import Loading from 'components/common/loading/Loading';
import BackButton from 'components/common/button/BackButton';

type HolidayRouteParams = {
  id?: string;
};

type HolidayRecord = {
  id: number;
  name: string;
  description: string;
  date: Moment;
  countries: string[] | null;
};

const CreateEditHoliday: React.FC<RouteComponentProps<HolidayRouteParams>> = (props) => {
  const holidayId = props.match.params?.id;
  const title = holidayId ? 'Edit Holiday' : 'Add Holiday';
  const setTitle = useTitle();

  useEffect(() => {
    setTitle(title);
  }, [setTitle, title]);

  const [loading, setLoading] = useState(Boolean(holidayId));
  const [holiday, setHoliday] = useState<HolidayRecord | null>(null);

  useEffect(() => {
    if (!holidayId) {
      return;
    }

    const fetchHoliday = async () => {
      try {
        const { data } = (await holidayService.fetchById(holidayId)) as {
          data: Omit<HolidayRecord, 'date'> & { date: string };
        };
        setHoliday({
          ...data,
          countries: data.countries ?? null,
          date: moment(data.date),
        });
      } catch (err) {
        handleError(err);
        history.push(routes.HOLIDAYS);
      } finally {
        setLoading(false);
      }
    };

    void fetchHoliday();
  }, [holidayId]);

  return (
    <div className="full-scope-card">
      <div className="full-scope-card__header table-header name-wrap">
        <div className="d-flex flex-row">
          <BackButton />
          <div className="d-flex flex-row">
            <div className="table-header">
              <h3 className="text-bold">{title}</h3>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <div className="loading-min-height">
          <Loading />
        </div>
      ) : (
        <HolidayForm holiday={holiday} />
      )}
    </div>
  );
};

export default CreateEditHoliday;
